































import PointNotation from "@/common/components/atoms/PointNotation.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconUserRank from "@/common/components/icons/IconUserRank.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { UserInfo } from "@/general/store/models";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";

@Component({
  name: "TheHeaderPointNotificationForSpLayout",
  components: {
    PointNotation,
    IconUserImage,
    IconUserRank
  }
})
export default class TheHeaderPointNotificationForSpLayout extends Vue {
  @Prop({ type: Number, required: true }) point!: number;

  userInfo: UserInfo = {} as UserInfo;

  // get point() {
  //   return commons.point;
  // }
  $refs!: {
    IconUserRank: any;
  };

  get userName() {
    return commons.getNameFromUser(commons.userInfo);
  }

  get userAvatar() {
    return commons.userInfo?.avatar;
  }

  get commonUserInfo(){
    return commons?.userInfo
  }

  //#59042�Ή��ɂ��Z�b�V���������擾����悤�ɏC��
  async created() {
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.userInfo = ic_session;
    })
    .catch(() => {
      this.userInfo = auth.user;
    });
  }
}
